<form [formGroup]="form" (ngSubmit)="accept()" novalidate>
    <div class="modal-header">
        <h4 class="modal-title">Su Voto</h4>
        <button type="button" class="close" aria-label="Close" (click)="dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="form-group col-md-12" style="display: none;">
                <label for="voto">Voto</label>
                <textarea rows="5" readonly="true" class="form-control" id="voto" formControlName="voto"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.voto.errors }">
                </textarea>
                <div *ngIf="submitted && form.controls.voto.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.voto.errors.required">Campo requerido</div>
                </div>
            </div>

            <div class="form-group col-md-12">
                <label for="numeroRastreo">Número de Rastreo</label>
                <textarea rows="5" readonly="true" class="form-control" id="numeroRastreo"
                    formControlName="numeroRastreo"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.numeroRastreo.errors }">
                </textarea>
                <div *ngIf="submitted && form.controls.numeroRastreo.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.numeroRastreo.errors.required">Campo requerido</div>
                </div>
            </div>
        </div>

        <div class="modal-footer full-width col-md-12">
            <div class="col-md-12 text-center">
                <span>¿Está de acuerdo con su voto?</span>
            </div>
            <div class="col-md-12 text-center">
                <button type="button" class="btn btn-danger btn-fidelis col-md-4" (click)="dismiss()">
                    <i class="fa fa-times-circle"></i>
                    No, deseo cambiar mi voto
                </button>
                <button type="submit" class="btn btn-success btn-fidelis col-md-4">
                    <i class="fa fa-check-circle"></i>
                    Sí, enviar mi voto
                </button>
            </div>
        </div>

    </div>
</form>